export default __webpack_public_path__ + "static/media/cd.096011a1.svg";